import {Component, OnInit} from '@angular/core';
import {ApiInterceptor, AuthService} from 'lib-auth';
import {environment} from '../environments/environment';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {AbstractAppRootComponent} from 'lib-components';

@Component({
    selector: 'app-root',
    templateUrl: './app-root.component.html',
    styleUrls: ['./app-root.component.scss'],
    standalone: false
})
export class AppRootComponent extends AbstractAppRootComponent implements OnInit {

    public hasPendingRequests = false;

    constructor(router: Router, authService: AuthService, translateService: TranslateService) {
        super(router, authService, translateService, environment);
    }

    ngOnInit(): void {
        dayjs.locale('fr');
        ApiInterceptor
            .pendingRequestsCountEvents
            .subscribe(value => this.hasPendingRequests = value !== 0);
    }
}
